import $ from "jquery";

window.jQuery = $;

// *****************************
// START OF NEW UNIVERSAL HEADER
// *****************************
// ANY CLICK OF A HEADER ITEM WILL START BY RESETTING THE DROPDOWNS
// FOR SAFETY
jQuery(document).on('click','.has-interchanged.has-loaded .dropdown-trigger', function(e) {
    e.preventDefault();
    $('.overlay__megamenu--hide').removeClass('overlay__megamenu--hide');
    $(this).addClass('overlay__megamenu--hide');
    $('#u-nav .active').removeClass('active');
    $(this).parent().addClass('active');
    resetDropdowns();
    createOverlay();
});

// REMOVE THE DROPDOWNS
function resetDropdowns() {
    // console.log('resetDropdowns();')
    // RESET LEVEL 2'S
    $('.u-nav--dropdown__right--main').show();
    $('.header-second-container').show();
    // RESET LEVEL 3'S
    $('.u-nav--dropdown__right--sub').hide();
    $('.header-third-container').hide();
    // RESET LEVEL LEFT HAND NAV'S
    $('.u-nav--dropdown-links__active').removeClass('u-nav--dropdown-links__active');
    $('.u-nav--dropdown-links').addClass('u-nav--dropdown-links--inactive');
}

// USER CLICKS ON A HEADER NAVIGATION LINK
// FOUNDATION WILL HANDLE THE DROPDOWN SHOWING AND HIDING
// THEY ARE SHOWN A NUMBER OF LEFT HAND NAV ITEMS
// IF THEY CLICK ONE OF THEM THE BELOW WILL TAKE PLACE
jQuery(document).on('click','.has-interchanged .u-nav--dropdown-wrapper .u-nav--dropdown-links__subsection a', function(e) {
    // START BY PREVENTING DEFAULT ACTION OF THE ANCHOR
    e.preventDefault();

    // REUSABLE CODE
    const parentDiv = $(this).closest('.u-nav--dropdown-wrapper').attr('id');
    const parentDivID = $('#'+parentDiv);
    const panel = '.header-third-container';
    const triggerClicked = $(this).attr("data-trigger");
    const effectIn = 'slide-in-left';

    // THIS APPLIES TO THE PARENT OF THE LIST OF LINKS
    // THIS IS NEEDED BECUASE OF THE VISUAL STATE DIFFERENCES
    // WHEN ACTIVE / INACTIVE AND WHEN IN A DEFAULT STATE
    $('.u-nav--dropdown-links__active').removeClass('u-nav--dropdown-links__active');
    $('.u-nav--dropdown-links--inactive').removeClass('u-nav--dropdown-links--inactive');
    $(this).parent().addClass('u-nav--dropdown-links__active');

    // AS WE KNOW WHEN A USER CLICKS ON A LEFT HAND NAV LINK
    // THEY WILL SEE A .header-third-container SET OF CONTENT
    // WE WILL HIDE THE MAIN .u-nav--dropdown__right--main
    // WE WILL SHOW THE CONTAINER .u-nav--dropdown__right--sub
    // AND MAKE SURE NO OTHER .header-third-container ARE BEING
    // SHOWN BEFORE WE REVEAL THE SPECIFIC ONE WE NEED
    parentDivID.find('.u-nav--dropdown__right--main').hide();
    parentDivID.find('.u-nav--dropdown__right--sub').show();
    parentDivID.find(panel).hide();
    parentDivID.find(panel).filter('[data-panel="'+triggerClicked+'"]').addClass(effectIn).show();
});

jQuery(document).on('click','.has-interchanged .u-nav--dropdown-wrapper .header-third-close', function(e) {
    // START BY PREVENTING DEFAULT ACTION OF THE ANCHOR
    e.preventDefault();
    // REUSABLE CODE
    const parentDiv = $(this).closest('.u-nav--dropdown-wrapper').attr('id');
    const parentDivID = $('#'+parentDiv);
    const effectIn = 'slide-in-right';

    // CALL RESET AND THEN ADD ANIMATION TO CONTENT
    resetDropdowns();
    parentDivID.find('.u-nav--dropdown__right--main .header-second-container').addClass(effectIn).show();
});

// CREATE THE OVERLAY
function createOverlay() {
    // console.log('createOverlay();')
    const overlayClass = "overlay__megamenu";
    const overlayHideClass = "overlay__megamenu--hide";

    // FIND ANY EXISTING OVERLAY AND REMOVE
    // TO PREVENT STACKING OF THEM
    $('.'+overlayClass).remove();
    // CREATE BRAND NEW OVERLAY ELEMENT
    // BUT HIDDEN
    $('body').append('<div class="'+overlayClass+'" style="display:none"></div>');
    // FADEIN FOR NICER EFFECT
    $('.'+overlayClass).fadeIn(0);

    // ANY CLICK ON OVERLAY OR ANY ELEMENT WITH THIS CLASS WILL CALL
    // REMOVEOVERLAY
    jQuery(document).on('click','.'+overlayClass, function(e) {
        removeOverlay();
        resetDropdowns();
    });
    jQuery(document).on('click','.'+overlayHideClass, function(e) {
        removeOverlay();
        resetDropdowns();
    });
    // IF THE CLICK IS IN THE BAR, BUT NOT ON A CLICKABLE TARGET, RESET THE OVERLAY
    jQuery(document).on('click','#u-nav.u-nav--v2', function(e) { 
    // console.log('Just the bar');
    // console.log(e);
    let pElement = e.target.parentElement.nodeName.toLowerCase();
    let pClassList = e.target.parentElement.classList;
    let pID = e.target.parentElement.id;
    // console.log(pElement);
    // console.log(pClassList);
    // console.log(pID);
        if ((pElement == 'section' && pClassList.contains('u-nav--large')) || (pElement == 'nav' && pClassList.contains('u-nav--v2')) || (pElement == 'header' && pID == 'u-header')) {
            // alert('You clicked it wrong');
            removeOverlay();
            resetDropdowns();
        }
    });
}

// REMOVE THE OVERLAY
function removeOverlay() {
    const overlayClass = ".overlay__megamenu";
    const overlayHideClass = "overlay__megamenu--hide";
    $('.dropdown-pane').foundation('close');
    $(overlayClass).fadeOut(0);
    $('#u-nav .active').removeClass('active');
    setTimeout(function(){
        $(overlayClass).remove();
        $('.'+overlayHideClass).removeClass(overlayHideClass);
    }, 100);
}

// CONTEXT MENU
// USER OPEN AND CLOSES A MENU ON THIS LEVEL
$('.u-nav--context-dropdown').on('opened', function() {
    $('.u-nav--context--level-one').addClass('has-active');
    $(this).closest('li').addClass('active');
});
$('.u-nav--context-dropdown').on('closed', function() {
    $('.u-nav--context--level-one.has-active').removeClass('has-active');
    $(this).closest('li').removeClass('active');
});

// SEARCH menu item
$('.u-nav--icons-search a').on('focus', function(e){
    $(window).keyup(function (e) {
        var code = (e.keyCode ? e.keyCode : e.which);
        // if user tabs on this item
        if (code == 9) {
            $('.u-nav--icons-search a').keydown(function (e){
                // if user then presses ENTER
                if(e.keyCode == 13){
                    $('.u-nav--icons-search a').keydown(function (e){
                        // if user tabs again take them to correct dropdown
                        if(e.keyCode == 9){
                            $('#drop12').focus();
                        }
                    })
                }
            })
        }
    });
});
$('.u-nav--icons-search a').on('click', function(event) {
    $('#u-nav--large--12 .magic-box-input input').focus();
});

// DROPDOWN SEARCH BOX
// AS USER TYPES IN THE INPUT BOX, WAIT FOR THEM TO
// TYPE SPECIFIC NUMBER OF CHARS AND THEN ADD A CLASS
// TO THE RESULTS DIV TO MAKE IT APPEAR
// THIS WILL NEED TO BE LINKED TO COVEO WHICH WILL RETURN
// THE RESULTS SHOWN IN THE CONTAINER.
// ALSO SHOW RESET BUTTON
jQuery(document).on('keyup','.search .search__box', function(e) {
    $('.search .search__reset').addClass('search__reset--show');
    const inputChar = $(this).val();
    if (inputChar.length > 2) {
        $('.search .search__results').addClass('search__results--show');
    } else if (inputChar.length == 0) {
        $('.search .search__reset.search__reset--show').removeClass('search__reset--show');
    } else {
        $('.search .search__results.search__results--show').removeClass('search__results--show');
    }
});

// DROPDOWN SEARCH BOX RESET
// WHEN USER CLICKS RESET WE CAN HIDE THIS BUTTON ITSELF
// IT IS REVEALED AGAIN WHEN USER TYPES INTO .search__box
jQuery(document).on('click','.search .search__reset', function(e) {
    $(this).removeClass('search__reset--show');
    $('.search .search__results.search__results--show').removeClass('search__results--show');
});

////////////////////////////////////////////////////////////////////////
//                                                                    //
//  FOR REMOVAL WHEN data-toggle="menu-topbar" ADDED TO API ENDPOINT  //
//                                                                    //
    function initSmall() {
        // console.log('initSmall()');
        var element2 = document.getElementById('mm-menu-button');
        if (element2) {
            element2.setAttribute('data-toggle', 'menu-topbar');
        }
    };
//  ALSO REMOVE REFERENCE FROM UHv2 - Medium menu interchange         //
//                                                                    //
////////////////////////////////////////////////////////////////////////

function initFoundation(interchangeBlock) {	
	// console.log('initFoundation()');
    // console.log(interchangeBlock);
    $(interchangeBlock + ' [data-dropdown]').foundation();
    $(interchangeBlock + ' [data-drilldown]').foundation();
	$(interchangeBlock + ' [data-responsive-toggle]').foundation();

	// $(interchangeBlock).removeAttr('data-interchange');
}

//////////////////// INTERCHANGE FOR UH2 ////////////////////


// UHv2 - Medium menu
$(document).on('replaced.zf.interchange', '#u-nav.u-nav--v2 #u-nav--medium[data-interchange]', function () {
	// console.log('UH2 Medium interchanged');
	var interchangeBlock = '#u-nav.u-nav--v2 #u-nav--medium[data-interchange]';
	initSmall();
	initFoundation(interchangeBlock);
});

// UHv2 - Large menu
$(document).on('replaced.zf.interchange', '#u-nav.u-nav--v2 .u-nav--links[data-interchange]', function () {
	// console.log('UHv2 Large menu has changed');
	var interchangeBlock = '#u-nav.u-nav--v2 .u-nav--links[data-interchange]';
    $(interchangeBlock).addClass('has-interchanged is-loading');
    // jQuery(window).on( "load", function() {
    window.onload = (event) => {
        $(interchangeBlock).addClass('has-loaded').removeClass('is-loading');
        initFoundation(interchangeBlock);
    };
});
// UHv2 - Large search
$(document).on('replaced.zf.interchange', '#u-nav.u-nav--v2 .u-nav--icons-search[data-interchange]', function () {
	// console.log('UHv2 Large search has changed');
	var interchangeBlock = '#u-nav.u-nav--v2 .u-nav--icons-search[data-interchange]';
	initFoundation(interchangeBlock);
});
// UHv2 - Large account
$(document).on('replaced.zf.interchange', '#u-nav.u-nav--v2 .u-nav--icons-account[data-interchange]', function () {
	// console.log('UHv2 Large account has changed');
	var interchangeBlock = '#u-nav.u-nav--v2 .u-nav--icons-account[data-interchange]';
	initFoundation(interchangeBlock);
});
// UHv2 - Large cart
$(document).on('replaced.zf.interchange', '#u-nav.u-nav--v2 .u-nav--icons-cart[data-interchange]', function () {
	// console.log('UHv2 Large cart has changed');
	var interchangeBlock = '#u-nav.u-nav--v2 .u-nav--icons-cart[data-interchange]';
	initFoundation(interchangeBlock);
});


// AFE
// MIXED TOP BAR INTERACTION
// WHERE MULTIPLE TOP BAR INSTANCES ARE ON THE SAME PAGE
// CLOSE ANY EXPANDED TOP BAR SECTIONS THAT ARE ALREADY OPEN
// jQuery(document).on('click','.top-bar:not(.expanded) .toggle-topbar', function(e) {
//     jQuery('#u-header .top-bar.expanded').removeClass('expanded');
//     jQuery(this).addClass('expanded');
//     jQuery('#u-header .top-bar').addClass('expanded');
// });

// IF USER HAS OPENED CONTEXT MENU ON SMALL
// AND THEN CLICKED ANOTHER PART OF PAGE
// HIDE THE CONTEXT MENU
// $(document).on('click','#u-nav--context', function(e) {
//     $(document).on('click','#viewport-wrap, footer', function(e) {
//         $('#u-header .top-bar.expanded').removeClass('expanded');
//     });
// });

// AFE
$(document).on('click','.top-bar .toggle-topbar a', function(e) {
    $(this).parents('.top-bar').toggleClass('expanded');
});


// ***************************
// END OF NEW UNIVERSAL HEADER
// ***************************
